/**
 * @generated SignedSource<<a204278b9bc831fef1668132c93b67d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JoinBookingScreenQuery$variables = {
  membershipTypeId: string;
  shareId: string;
};
export type JoinBookingScreenQuery$data = {
  readonly sharedBooking: {
    readonly " $fragmentSpreads": FragmentRefs<"ConfirmPanel_Booking" | "InvitePanel_Booking" | "useHandleUserAlreadyInBooking_Booking">;
  } | null | undefined;
};
export type JoinBookingScreenQuery = {
  response: JoinBookingScreenQuery$data;
  variables: JoinBookingScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "shareId",
    "variableName": "shareId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "singular",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v14 = [
  {
    "kind": "Literal",
    "name": "memberVisible",
    "value": true
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customCode",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v19 = {
  "kind": "Literal",
  "name": "type",
  "value": "CUSTOMER"
},
v20 = {
  "alias": "nineHolePrice",
  "args": (v18/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
},
v21 = {
  "alias": "eighteenHolePrice",
  "args": (v17/*: any*/),
  "kind": "ScalarField",
  "name": "totalGolfPrice",
  "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "holeCount",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "JoinBookingScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedBooking",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "InvitePanel_Booking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useHandleUserAlreadyInBooking_Booking"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ConfirmPanel_Booking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JoinBookingScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "sharedBooking",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isBooking"
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ownerClient",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Customer",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v7/*: any*/),
                "type": "Member",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "startSlot",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Facility",
                    "kind": "LinkedField",
                    "name": "facility",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Department",
                        "kind": "LinkedField",
                        "name": "department",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseConnection",
                        "kind": "LinkedField",
                        "name": "courses",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "lesson",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "slug",
                        "storageKey": null
                      },
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bookingPolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showBookingPolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lessonsPolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "showLessonsPolicy",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Club",
                        "kind": "LinkedField",
                        "name": "club",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "supportsPrivate",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PublicBookingPermissionSet",
                        "kind": "LinkedField",
                        "name": "publicBookingPermissionSet",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "prePaymentRequirement",
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "rateDisplay",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": (v14/*: any*/),
                "concreteType": "TransportationType",
                "kind": "LinkedField",
                "name": "transportationTypes",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": "eighteenHolePrice",
                    "args": (v17/*: any*/),
                    "kind": "ScalarField",
                    "name": "totalPrice",
                    "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
                  },
                  {
                    "alias": "nineHolePrice",
                    "args": (v18/*: any*/),
                    "kind": "ScalarField",
                    "name": "totalPrice",
                    "storageKey": "totalPrice(holeCount:\"NINE\")"
                  }
                ],
                "storageKey": "transportationTypes(memberVisible:true)"
              },
              {
                "alias": null,
                "args": [
                  (v19/*: any*/)
                ],
                "concreteType": "SlotRate",
                "kind": "LinkedField",
                "name": "playerRates",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "rate",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": "playerRates(type:\"CUSTOMER\")"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requirePlayerCounts",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "bookingType",
                        "value": "STANDARD"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "availableCapacity",
                    "storageKey": "availableCapacity(bookingType:\"STANDARD\")"
                  },
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "course",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WeatherCondition",
                    "kind": "LinkedField",
                    "name": "weatherCondition",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "temperature",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weatherCategory",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "measurementSystem",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "windSpeedInMph",
                        "storageKey": null
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v14/*: any*/),
                    "concreteType": "CourseLayoutConnection",
                    "kind": "LinkedField",
                    "name": "permittedCourseLayouts",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayoutEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseLayout",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v23/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "permittedCourseLayouts(memberVisible:true)"
                  },
                  {
                    "alias": "filteredPlayerRates",
                    "args": [
                      (v19/*: any*/),
                      {
                        "kind": "Variable",
                        "name": "visibleToMembershipTypeId",
                        "variableName": "membershipTypeId"
                      }
                    ],
                    "concreteType": "SlotRate",
                    "kind": "LinkedField",
                    "name": "playerRates",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "rate",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "membershipTypeId",
                                "variableName": "membershipTypeId"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "appliesToMembershipType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v22/*: any*/)
                ],
                "type": "BucketTimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RoundConnection",
            "kind": "LinkedField",
            "name": "rounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoundEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "player",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseLayout",
                        "kind": "LinkedField",
                        "name": "courseLayout",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TransportationType",
                        "kind": "LinkedField",
                        "name": "transportationType",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v4/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoundRate",
                        "kind": "LinkedField",
                        "name": "roundRate",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "rate",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "appliesToMembershipType",
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isRound"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BookingSeries",
            "kind": "LinkedField",
            "name": "bookingSeries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recurrenceType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "repeatInterval",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCondition",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "effectiveEndDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "requestedOccurrenceCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 366
                  },
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": [
                      {
                        "direction": "DESC",
                        "field": "DATE_TIME"
                      }
                    ]
                  }
                ],
                "concreteType": "BookingConnection",
                "kind": "LinkedField",
                "name": "bookings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BookingEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "startSlot",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Agenda",
                                "kind": "LinkedField",
                                "name": "agenda",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "bookings(first:366,orderBy:[{\"direction\":\"DESC\",\"field\":\"DATE_TIME\"}])"
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shareId",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "rate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "durationMins",
                "storageKey": null
              }
            ],
            "type": "StandardBooking",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a9980a3768db09a6b2dc6ab8e7502b76",
    "id": null,
    "metadata": {},
    "name": "JoinBookingScreenQuery",
    "operationKind": "query",
    "text": "query JoinBookingScreenQuery(\n  $shareId: String!\n  $membershipTypeId: ID!\n) {\n  sharedBooking(shareId: $shareId) {\n    __typename\n    ...InvitePanel_Booking\n    ...useHandleUserAlreadyInBooking_Booking\n    ...ConfirmPanel_Booking\n    id\n  }\n}\n\nfragment ActionButton_Booking on Booking {\n  __isBooking: __typename\n  ...useJoinBooking_Booking\n}\n\nfragment BookingInfo_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  startSlot {\n    __typename\n    ... on BucketTimeSlot {\n      time\n    }\n    ... on TimeSlot {\n      time\n      dateTime\n      weatherCondition {\n        temperature\n        weatherCategory\n        measurementSystem\n        windSpeedInMph\n        id\n      }\n      course {\n        name\n        id\n      }\n    }\n    agenda {\n      date\n      facility {\n        type\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  bookingSeries {\n    recurrenceType\n    repeatInterval\n    endCondition\n    effectiveEndDate\n    requestedOccurrenceCount\n    bookings(first: 366, orderBy: [{field: DATE_TIME, direction: DESC}]) {\n      edges {\n        node {\n          __typename\n          id\n          startSlot {\n            __typename\n            agenda {\n              date\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment BookingPolicy_Booking on Booking {\n  __isBooking: __typename\n  id\n  __typename\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        bookingPolicy\n        showBookingPolicy\n        lessonsPolicy\n        showLessonsPolicy\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ConfigureRoundCourseLayoutControl_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    ... on TimeSlot {\n      permittedCourseLayouts(memberVisible: true) {\n        edges {\n          node {\n            id\n            holeCount\n            code\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment ConfigureRoundGolfPlayerRateControl_Booking on Booking {\n  __isBooking: __typename\n  ...useGetGolfPlayerRateOptions_Booking\n}\n\nfragment ConfigureRoundTransportationTypeControl_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    transportationTypes(memberVisible: true) {\n      id\n      code\n      name\n      customCode\n      eighteenHolePrice: totalPrice(holeCount: EIGHTEEN)\n      nineHolePrice: totalPrice(holeCount: NINE)\n    }\n    id\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment ConfigureRound_Booking on Booking {\n  __isBooking: __typename\n  ...ConfigureRoundTransportationTypeControl_Booking\n  ...ConfigureRoundCourseLayoutControl_Booking\n  ...ConfigureRoundGolfPlayerRateControl_Booking\n  ...useInitializeRound_Booking\n  startSlot {\n    __typename\n    id\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        publicBookingPermissionSet {\n          rateDisplay\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n  ownerClient {\n    __typename\n    ... on Member {\n      id\n    }\n    ... on Customer {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ConfirmPanel_Booking on Booking {\n  __isBooking: __typename\n  ...BookingInfo_Booking\n  ...BookingPolicy_Booking\n  ...PaymentDisplay_Booking\n  ...PlayerList_Booking\n  ...ActionButton_Booking\n  ...YourRound_Booking\n}\n\nfragment InviteCardActionButton_Booking on Booking {\n  __isBooking: __typename\n  ...useJoinableSpots_Booking\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment InviteCardBookingInfoSection_Booking on Booking {\n  __isBooking: __typename\n  ...useJoinableSpots_Booking\n  startSlot {\n    __typename\n    agenda {\n      date\n      facility {\n        courses {\n          count\n        }\n        copyOverrides {\n          course {\n            singular\n          }\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      course {\n        name\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment InviteCardTopSection_Booking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Customer {\n      firstName\n      lastName\n    }\n    ... on Member {\n      firstName\n      lastName\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        department {\n          type\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment InvitePanel_Booking on Booking {\n  __isBooking: __typename\n  ...InviteCardTopSection_Booking\n  ...InviteCardBookingInfoSection_Booking\n  ...InviteCardActionButton_Booking\n  ...useHandleUserAlreadyInBooking_Booking\n}\n\nfragment OtherPlayersInThisBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  ownerClient {\n    __typename\n    ... on Customer {\n      id\n    }\n    ... on Member {\n      id\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          id\n          fullName\n          firstName\n          lastName\n        }\n        courseLayout {\n          holeCount\n          id\n        }\n        transportationType {\n          code\n          customCode\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PaymentDisplay_Booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    rate {\n      __typename\n      id\n    }\n    paymentStatus\n    rounds {\n      edges {\n        node {\n          __typename\n          roundRate {\n            rate {\n              __typename\n              id\n            }\n          }\n          paymentStatus\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PlayerList_Booking on Booking {\n  __isBooking: __typename\n  ...OtherPlayersInThisBooking_Booking\n}\n\nfragment SelectActivityManagementRound_Booking on Booking {\n  __isBooking: __typename\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        roundRate {\n          rate {\n            __typename\n            id\n            name\n          }\n        }\n        player {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SelectRound_Booking on Booking {\n  __isBooking: __typename\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        courseLayout {\n          holeCount\n          id\n        }\n        transportationType {\n          id\n        }\n        roundRate {\n          rate {\n            __typename\n            id\n          }\n        }\n        ...SelectableGolfRound_Round\n        player {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment SelectableGolfRound_Round on Round {\n  __isRound: __typename\n  id\n  roundRate {\n    rate {\n      __typename\n      name\n      id\n    }\n  }\n  transportationType {\n    id\n    code\n    customCode\n    name\n  }\n  courseLayout {\n    holeCount\n    id\n  }\n  player {\n    __typename\n    id\n  }\n}\n\nfragment YourRound_Booking on Booking {\n  __isBooking: __typename\n  ...SelectRound_Booking\n  ...ConfigureRound_Booking\n  ...SelectActivityManagementRound_Booking\n  id\n  shareId\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        publicBookingPermissionSet {\n          prePaymentRequirement\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    durationMins\n  }\n  rounds {\n    count\n    edges {\n      node {\n        __typename\n        id\n      }\n    }\n  }\n}\n\nfragment useGetGolfPlayerRateOptions_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    agenda {\n      facility {\n        club {\n          supportsPrivate\n          id\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      filteredPlayerRates: playerRates(type: CUSTOMER, visibleToMembershipTypeId: $membershipTypeId) {\n        rate {\n          __typename\n          id\n          name\n          visibility\n          appliesToMembershipType(membershipTypeId: $membershipTypeId)\n        }\n        nineHolePrice: totalGolfPrice(holeCount: NINE)\n        eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n      }\n    }\n  }\n}\n\nfragment useHandleUserAlreadyInBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment useInitializeRound_Booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    id\n    ... on TimeSlot {\n      agenda {\n        facility {\n          type\n          id\n        }\n        id\n      }\n      permittedCourseLayouts(memberVisible: true) {\n        edges {\n          node {\n            id\n            holeCount\n          }\n        }\n      }\n    }\n    playerRates(type: CUSTOMER) {\n      rate {\n        __typename\n        id\n        name\n      }\n      nineHolePrice: totalGolfPrice(holeCount: NINE)\n      eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n    }\n  }\n  rounds {\n    edges {\n      node {\n        id\n        __typename\n        transportationType {\n          id\n        }\n        courseLayout {\n          id\n          holeCount\n        }\n        roundRate {\n          appliesToMembershipType\n          nineHolePrice: totalGolfPrice(holeCount: NINE)\n          eighteenHolePrice: totalGolfPrice(holeCount: EIGHTEEN)\n          rate {\n            __typename\n            id\n            name\n            visibility\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment useJoinBooking_Booking on Booking {\n  __isBooking: __typename\n  id\n  shareId\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        club {\n          visibility\n          id\n        }\n        publicBookingPermissionSet {\n          prePaymentRequirement\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n  rounds {\n    edges {\n      node {\n        id\n        __typename\n        player {\n          __typename\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment useJoinableSpots_Booking on Booking {\n  __isBooking: __typename\n  ... on StandardBooking {\n    paymentStatus\n  }\n  rounds {\n    edges {\n      node {\n        __typename\n        player {\n          __typename\n          id\n        }\n        paymentStatus\n        id\n      }\n    }\n  }\n  startSlot {\n    __typename\n    agenda {\n      facility {\n        type\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      requirePlayerCounts\n      availableCapacity(bookingType: STANDARD)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bff2329429b8232162e025d834069a5b";

export default node;
